/** Leads (CRM) API calls — spec §1 pipeline. */

import {
  apiDelete,
  apiGet,
  apiPatch,
  apiPost,
  BASE_URL,
  type PaginatedResponse,
  type QueryParams,
} from "@/lib/api-client";
import { getAccessToken } from "@/lib/auth-token";
import type { ApiLead, ApiLeadContact, ApiStageEntry, TransitionInput } from "./leads.adapter";

export interface LeadsListParams {
  page?: number;
  limit?: number;
  search?: string;
  stage?: string;
  archived?: boolean;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const leadsApi = {
  list: (params: LeadsListParams = {}) =>
    apiGet<PaginatedResponse<ApiLead>>("/leads", params as QueryParams),
  create: (body: Record<string, unknown>) => apiPost<ApiLead>("/leads", body),
  update: (id: string, body: Record<string, unknown>) => apiPatch<ApiLead>(`/leads/${id}`, body),
  transition: (id: string, body: TransitionInput) =>
    apiPost<{ lead: ApiLead; stageEntryId: string; clientId: string | null }>(
      `/leads/${id}/transition`,
      body as unknown as Record<string, unknown>,
    ),
  history: (id: string) => apiGet<{ data: ApiStageEntry[] }>(`/leads/${id}/history`),
  addContact: (id: string, body: Record<string, unknown>) =>
    apiPost<ApiLeadContact>(`/leads/${id}/contacts`, body),
  archive: (id: string) => apiDelete<ApiLead>(`/leads/${id}`),
  restore: (id: string) => apiPost<ApiLead>(`/leads/${id}/restore`),
  /** files uploaded in transition pop-ups are served by the shared agency download route */
  downloadFile: async (id: string, name: string) => {
    const token = getAccessToken();
    const res = await fetch(`${BASE_URL}/client-portal-admin/files/${id}/download`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error("Téléchargement impossible");
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.click();
    URL.revokeObjectURL(url);
  },
};
